/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DisabledIntegration
 */
export interface DisabledIntegration {
    /**
     * The type of integration that is disabled
     */
    integration_type: string;
    /**
     * The scope of the disabled integration (global, organization, or organization:facility)
     */
    org_fac_key: string;
    /**
     * User ID who disabled the integration
     */
    disabled_by: string;
    /**
     * Unix timestamp when the integration was disabled
     */
    disabled_at: number;
    /**
     * Unix timestamp when the integration should be automatically re-enabled (optional)
     */
    reenable_time?: number;
    /**
     * Why the integration was disabled (e.g., "SITE_VERIFICATION", "ACCOUNT_LOCKED", "INTEGRATION_IS_DOWN", "OTHER")
     */
    reason?: string;
    /**
     * Intake triggers that are paused. An absent or empty list disables all triggers.
     */
    disabled_triggers?: Array<DisabledIntegrationDisabledTriggersEnum>;
}


/**
 * @export
 */
export const DisabledIntegrationDisabledTriggersEnum = {
    Schedule: 'schedule',
    Email: 'email',
} as const;
export type DisabledIntegrationDisabledTriggersEnum = typeof DisabledIntegrationDisabledTriggersEnum[keyof typeof DisabledIntegrationDisabledTriggersEnum];


/**
 * Check if a given object implements the DisabledIntegration interface.
 */
export function instanceOfDisabledIntegration(value: object): value is DisabledIntegration {
    if (!('integration_type' in value) || value['integration_type'] === undefined) return false;
    if (!('org_fac_key' in value) || value['org_fac_key'] === undefined) return false;
    if (!('disabled_by' in value) || value['disabled_by'] === undefined) return false;
    if (!('disabled_at' in value) || value['disabled_at'] === undefined) return false;
    return true;
}

export function DisabledIntegrationFromJSON(json: any): DisabledIntegration {
    return DisabledIntegrationFromJSONTyped(json, false);
}

export function DisabledIntegrationFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisabledIntegration {
    if (json == null) {
        return json;
    }
    return {
        
        'integration_type': json['integration_type'],
        'org_fac_key': json['org_fac_key'],
        'disabled_by': json['disabled_by'],
        'disabled_at': json['disabled_at'],
        'reenable_time': json['reenable_time'] == null ? undefined : json['reenable_time'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'disabled_triggers': json['disabled_triggers'] == null ? undefined : json['disabled_triggers'],
    };
}

export function DisabledIntegrationToJSON(json: any): DisabledIntegration {
    return DisabledIntegrationToJSONTyped(json, false);
}

export function DisabledIntegrationToJSONTyped(value?: DisabledIntegration | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'integration_type': value['integration_type'],
        'org_fac_key': value['org_fac_key'],
        'disabled_by': value['disabled_by'],
        'disabled_at': value['disabled_at'],
        'reenable_time': value['reenable_time'],
        'reason': value['reason'],
        'disabled_triggers': value['disabled_triggers'],
    };
}

